/**
 * Идентичность отряда, опросы и продление сезона (BLUEPRINT Stage 12, механики 2.2.6 и 2.2.9).
 * Только числа и наборы значений: правила — в `domain/identity.ts` и `domain/renewal.ts`,
 * тексты — в `texts.ts`.
 */

export const IDENTITY = {
  /** После скольких проведённых сборов запускается опрос о названии */
  nameAfterGatherings: 2,
  /** Сколько вариантов уходит в опрос (BLUEPRINT Stage 12, задача 1) */
  namePollOptions: 4,
  /** Сколько часов открыт опрос о названии */
  namePollHours: 48,
  nameMinLength: 2,
  nameMaxLength: 24,
} as const;

/** Доп. сбор по опросу (2.2.6): «кто в баню в субботу?» */
export const EXTRA_POLL = {
  /** Сколько «да» нужно, чтобы сбор состоялся */
  minYes: 4,
  /** Сколько дат можно предложить за раз */
  maxDateOptions: 3,
  /** Сколько часов открыт опрос */
  pollHours: 48,
  /** Не раньше чем за столько часов до предложенной даты можно бросить опрос */
  minLeadHours: 12,
  /** На сколько дней вперёд можно предлагать дату */
  maxAheadDays: 30,
} as const;

/** Продление сезона (Stage 12, задача 5). */
export const RENEWAL = {
  /** После какого по счёту сбора создаётся черновик следующего сезона */
  afterGatheringIndex: 5,
  /** Сколько дней даётся на продление (дедлайн = момент предложения + столько дней) */
  windowDays: 10,
  /** Меньше стольких продлений — отряд уходит в PAUSED, участникам предлагают пул */
  pauseBelow: 4,
} as const;

/**
 * Набор эмблем отряда: 24 кода, рисунок — SVG в приложении (`components/Emblem.tsx`).
 * Код хранится в `Squad.emblem`; менять список можно только добавлением в конец.
 */
export const EMBLEMS = [
  'shield',
  'flame',
  'bolt',
  'anchor',
  'axe',
  'bear',
  'wolf',
  'falcon',
  'boar',
  'lion',
  'compass',
  'mountain',
  'wave',
  'pine',
  'star',
  'crown',
  'hammer',
  'horns',
  'arrow',
  'fist',
  'gear',
  'torch',
  'rook',
  'flag',
] as const;

export type Emblem = (typeof EMBLEMS)[number];
